import { buildApiUrl, fetchJSON, validateRequiredParams } from '../crm/crmApi';

export interface SupplierDashboardSummary {
  totals: {
    suppliers: number;
    activeSuppliers: number;
    contacts: number;
    quotes: number;
  };
  pipeline: {
    openValue: number;
    pendingQuotes: number;
    draftQuotes: number;
    acceptedQuotes: number;
  };
  quotesByStatus: Record<string, number>;
  updatedAt: string;
}

export async function fetchSupplierDashboardSummary(
  organization_id: string
): Promise<SupplierDashboardSummary> {
  validateRequiredParams({ organization_id }, ['organization_id'], {
    service: 'supplierCrm.dashboard.summary'
  });

  const url = buildApiUrl('/api/supplier-crm/dashboard/summary', { organization_id });
  return fetchJSON<SupplierDashboardSummary>(url, {
    description: 'Fetch supplier dashboard summary',
    context: { organization_id }
  });
}
